{
  "pt": {
    "building": {
      "attributes": {
        "description": "Descrição",
        "elevators": "Número de elevadores",
        "end_date": "Data final",
        "floors": "Número de pisos",
        "internal_note": "Nota interna do edifício",
        "name": "Nome",
        "start_date": "Data de início",
        "surface_shared": "Área de espaço partilhado"
      },
      "labels": {
        "building": "Nenhum edifício | Um edifício | {count} Edifícios"
      },
      "toasts": {
        "create": "Edifício criado",
        "delete": "Edifício suprimido",
        "update": "Edifício atualizado"
      },
      "validation": {
        "needName": "O título é obrigatório",
        "needNumber": "Deve ser um número (por exemplo, 85)"
      }
    }
  }
}